/* eslint-disable no-empty */
import { ResponseBaseGetBasketballGamesStatistics } from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const statisticsApi = createApi({
  reducerPath: 'apiStatistics',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    /**************************************************************************
     *                              BASKETBALL
     *************************************************************************/
    fetchBasketballGamesStatistics: builder.query<
      ResponseBaseGetBasketballGamesStatistics,
      { from: string; till: string }
    >({
      query: (request) =>
        `/statistics/basketball/games?from=${request.from}&till=${request.till}`,
    }),
    fetchBasketballPracticesStatistics: builder.query<
      ResponseBaseGetBasketballGamesStatistics,
      { from: string; till: string }
    >({
      query: (request) =>
        `/statistics/basketball/practices?from=${request.from}&till=${request.till}`,
    }),
    fetchTaskStatistics: builder.query<
      ResponseBaseGetBasketballGamesStatistics,
      { taskId: string; from: string; till: string }
    >({
      query: (request) =>
        `/statistics/tasks/${request.taskId}?from=${request.from}&till=${request.till}`,
    }),
    fetchUsersStatistics: builder.query<
      ResponseBaseGetBasketballGamesStatistics,
      void
    >({
      query: () => `/statistics/users`,
    }),
  }), // end of endpoints
});

// Export hooks for usage in functional components
export const {
  useFetchBasketballGamesStatisticsQuery,
  useFetchBasketballPracticesStatisticsQuery,
  useLazyFetchTaskStatisticsQuery,
  useFetchUsersStatisticsQuery,
  reducerPath,
  reducer,
  middleware,
} = statisticsApi;
